<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F7004 pattern -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
        
        <!-- Entity information table -->
        <table class="table table-bordered form-inline enityDetails custom-table">
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.key }}</span>
            </td>
}
          </tr>
          <tr>
            @for (item of entityList; track $index) {
<td>
              <span>{{ item.value }}</span>
            </td>
}
          </tr>
        </table>
        
        <!-- Header Table with Name and EIN -->
        @if (tableHeader && tableHeader.length > 0) {
<table class="table table-bordered form-inline custom-table">
          <tr>
            @if (tableHeader && tableHeader[0]) {
<td>{{tableHeader[0].description}}:
              <div>
                <input 
                  class="form-control input-md numText" 
                  type="text" 
                  maxlength="19"
                  [(ngModel)]="tableHeader[0].value" 
                  disabled
                  aria-describedby="basic-addon2">
              </div>
            </td>
}
            @if (tableHeader && tableHeader.length > 1) {
<td>{{tableHeader[1].description}}:
              <div>
                <input 
                  class="form-control input-md numText" 
                  type="text"
                  maxlength="10"
                  [(ngModel)]="tableHeader[1].value" 
                  disabled
                  aria-describedby="basic-addon2">
              </div>
            </td>
}
          </tr>
        </table>
}

        <!-- Main Form Table -->
        <table class="I_Entry table table-bordered form-inline custom-table">
          <thead>
            <tr>
              <th colspan="10">{{modalTitle}}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleNFormView; track itemTracker(i, row); let i = $index) {
<tr 
              class="formDataBlock" 
             >
              
              <!-- Line Number -->
              <td class="col-md-1">{{row.num}}</td>
              
              <!-- Description -->
              <td class="descBlock col-md-9">
                <span>{{row.description}}</span>
              </td>
              
              <!-- Input Field -->
              <td class="col-md-2">
                
                <!-- Radio/Checkbox Input for Yes/No - FIXED: Use radio buttons instead of checkboxes -->
                @if (row.edit_type === 'radio') {
<div>
                  <span style="vertical-align: text-bottom;">Yes </span>
                  <input 
                    type="radio" 
                    [name]="'radio_' + i + '_' + row.num" 
                    [value]="true"
                    [checked]="row.value === true"
                    (change)="onRadioChange(i, true, row)">
                  
                  <span style="margin-left: 4px; vertical-align: text-bottom;">No </span>
                  <input 
                    type="radio" 
                    [name]="'radio_' + i + '_' + row.num" 
                    [value]="false"
                    [checked]="row.value === false"
                    (change)="onRadioChange(i, false, row)">
                </div>
}

                <!-- Multi-select for Countries (line 6b) -->
                @if (row.num === '6b' && CountriesList.values && CountriesList.values.length > 0) {
<div class="multiselect-container">
                  <div class="dropdown" [class.open]="isCountryDropdownOpen">
                    <button 
                      type="button"
                      class="btn btn-default dropdown-toggle form-control input-sm"
                      (click)="toggleCountryDropdown($event)"
                      [disabled]="row.conditionalField">
                      <span class="pull-left">
                        {{getCountryHeaderText()}}
                      </span>
                      <span class="caret pull-right"></span>
                    </button>
                    
                    <ul class="dropdown-menu" style="width: 100%; max-height: 300px; overflow-y: auto;">
                      <!-- Search filter -->
                      <li class="dropdown-header">
                        <input 
                          type="text" 
                          class="form-control input-sm" 
                          placeholder="Filter countries..."
                          [(ngModel)]="countrySearchText"
                          (click)="$event.stopPropagation()">
                      </li>
                      
                      <!-- Select All / Unselect All -->
                      <li class="dropdown-header">
                        <button 
                          type="button"
                          class="btn btn-link btn-sm"
                          (click)="selectAllCountries(); $event.stopPropagation()">
                          <i class="fa fa-check"></i> Select All
                        </button>
                        <button 
                          type="button"
                          class="btn btn-link btn-sm"
                          (click)="unselectAllCountries(); $event.stopPropagation()">
                          <i class="fa fa-times"></i> Unselect All
                        </button>
                      </li>
                      
                      <li class="divider"></li>
                      
                      <!-- Country options -->
                      @for (country of getFilteredCountries(); track $index) {
<li (click)="$event.stopPropagation()">
                        <a href="#" (click)="toggleCountrySelection(country); $event.preventDefault()">
                          <i [class]="isCountrySelected(country) ? 'fa fa-check-square-o' : 'fa fa-square-o'"></i>
                          {{country.LABEL}}
                        </a>
                      </li>
}
                    </ul>
                  </div>
                </div>
}

                <!-- Text/Number Input for specific lines -->
                @if (row.num === '1b' || row.num === '1c' || row.num === '2' || row.num === '4b' || row.num === '7b' || row.num === '7c') {
<input 
                 
                  type="text" 
                  [(ngModel)]="row.value"
                  [name]="row.num"
                  [disabled]="row.conditionalField"
                  class="form-control input-sm"
                  style="text-align: right;">
}
                  
              </td>
            </tr>
}
          </tbody>
        </table>
        </div>
}
      </div>
    </div>
}
  </div>


<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>